const menu = {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer',
      /*badge: {
        variant: 'primary',
        text: 'NEW'
      }*/
    },
    {
      name: 'Pedidos',
      icon: 'fa fa-list-alt',
      children: [
        {
          name: 'Alocações',
          url: '/orders/item-in/all',
          icon: 'fa fa-sign-in',
          alias: 'entrance',
          badgeColor: 'info'
        },
        {
          name: 'Separações',
          url: '/orders/item-out/all',
          icon: 'fa fa-sign-out',
          alias: 'exit',
          badgeColor: 'primary'
        },
        {
          name: 'Realocações',
          url: '/orders/item-reallocation/all',
          icon: 'fa fa-undo',
          alias: 'reallocation',
          badgeColor: 'warning',
          operation: 'RAL'
        },
        {
          name: 'Ajustes',
          url: '/orders/item-adjustment/all',
          icon: 'cui-task',
          alias: 'stockAdjustment',
          badgeColor: 'danger',
          requiredModules: ['Adjustments'],
          operation: 'AJU'
        },
        {
          name: 'Transformações',
          url: '/orders/transformations/all',
          icon: 'fa fa-industry',
          alias: 'transformation',
          badgeColor: 'success',
          operation: 'TRANSFORMACAO'
        },
      ]
    },
    /*{
      name: 'Armazém',
      icon: 'fa fa-industry',
      authorities: 'ROLE_ADMIN',
      children: [

      ]
    },*/
    {
      name: 'Endereços',
      icon: 'fa fa-map-marker',
      children: [
        {
          name: 'Armazéns',
          url: '/warehouse/all',
          icon: 'fa fa-cubes',
        },
        {
          name: 'Itens',
          url: '/warehouse/items/all',
          icon: 'fa fa-cube',
        },
        {
          name: 'Agrupadores',
          url: '/warehouse/groupers/all',
          icon: 'fa fa-object-group',
        },
        {
          name: 'Regras',
          url: '/allocation-rules',
          icon: 'fa fa-list-ol',
          requiredModules: ['Orders']
        },
      ]
    },
    {
      name: 'Outros',
      icon: 'fa fa-info-circle',
      children: [
        {
          name: 'Relatórios',
          url: '/reports',
          icon: 'fa fa-file',
          requiredModules: ['WMSReports']
        },
        {
          name: 'Configurações',
          url: '/config',
          icon: 'fa fa-cog',
        },
        {
          name: 'Etiquetas',
          url: '/etiquetas',
          icon: 'fa fa-tags',
          requiredModules: ['Items']
        },
        {
          name: 'Sincronização',
          url: '/sync',
          icon: 'fa fa-exchange',
        },
        {
          name: 'Usuários',
          url: '/users',
          icon: 'fa fa-user',
          requiredModules: ['Users']
        },
        {
          name: 'Perfis',
          url: '/profiles',
          icon: 'fa fa-users',
          requiredModules: ['Users']
        },
        {
          name: 'Parâmetros',
          url: '/parameters',
          icon: 'fa fa-cog',
          requiredModules: ['Parameters']
        }
      ]
    },

    // {
    //   name: 'Alocações',
    //   url: '/allocations/all',
    //   icon: 'fa fa-cubes',
    //   children: [
    //     {
    //       name: 'Todos',
    //       url: '/allocations/all',
    //       icon: 'icon-layers',
    //       authorities: 'ROLE_USER',
    //     },
    //     {
    //       name: 'Nova',
    //       url: '/allocations/new',
    //       icon: 'icon-plus',
    //       authorities: 'ROLE_ADMIN',
    //     },
    //     {
    //       name: 'Endereçamento',
    //       url: '/allocations/address',
    //       icon: 'icon-puzzle',
    //       authorities: 'ROLE_ADMIN',
    //     },
    //   ],
    // },
    // {
    //   title: true,
    //   name: 'Pedidos',
    //   class: '',
    //   wrapper: {
    //     element: '',
    //     address: {}
    //   }
    // },
    // {
    //   name: 'Entrada de Item',
    //   url: '/order/item-in/all',
    //   icon: 'cui-task'
    // },
    // {
    //   name: 'Separação',
    //   url: '/order/prepare/all',
    //   icon: 'cui-cart'
    // },
    // {
    //   title: true,
    //   name: 'Ações Internas',
    //   class: '',
    //   wrapper: {
    //     element: '',
    //     address: {}
    //   }
    // },
    // {
    //   name: 'Alocação',
    //   url: '/allocations/all',
    //   icon: 'fa fa-cubes',
    //   children: [
    //     {
    //       name: 'Todos',
    //       url: '/allocations/all',
    //       icon: 'icon-layers'
    //     },
    //     {
    //       name: 'Nova',
    //       url: '/allocations/new',
    //       icon: 'icon-plus'
    //     },
    //     {
    //       name: 'Attributos',
    //       url: '/allocations/address',
    //       icon: 'icon-puzzle'
    //     },
    //   ]
    // },
    // {
    //   name: 'Realocação',
    //   url: '/reallocations/all',
    //   icon: 'icon-refresh',
    //   children: [
    //     {
    //       name: 'Todos',
    //       url: '/reallocations/all',
    //       icon: 'icon-layers'
    //     },
    //   ]
    // },
    // {
    //   name: 'Configurações',
    //   url: '/configurations',
    //   icon: 'fa fa-wrench',
    // },
  ],
}

const filterRoutes = (routes, authUser) => {
  let operations = [];

  if (
    authUser.profile &&
    authUser.profile.restrictions &&
    authUser.profile.restrictions.order &&
    authUser.profile.restrictions.order.fiscal_operations &&
    authUser.profile.restrictions.order.fiscal_operations.length
  ) {
    operations = authUser.profile.restrictions.order.fiscal_operations;
  }

  return routes.filter(item => {
    if (authUser) {
      if (item.onlyForTeoremaUsers) {
        return authUser.companyGroup && authUser.companyGroup.name === 'teorema'
      }

      if (item.requiredModules && item.requiredModules.length && authUser.profile && authUser.profile.modules) {
        for (let i = 0; i < item.requiredModules.length; i++) {
          let moduleName = item.requiredModules[i].toUpperCase();
          let profileModule = authUser.profile.modules.find(pm => {
            return pm.name && pm.name.toString().toUpperCase() == moduleName
          });

          let hasAccess = profileModule && profileModule.canExecute;
          if (!hasAccess) {
            return false;
          }
        }
      }

      if (item.operation && operations.length && !operations.includes(item.operation)) {
        return false;
      }
    }

    if (item.children) {
      item.children = filterRoutes(item.children, authUser);
    }

    return true;
  });
}

export const items = (/*ordersCounts, */authUser) => {
  let menuItems = filterRoutes(menu.items, authUser);

  /*if (ordersCounts && Object.keys(ordersCounts).length) {
    menuItems.forEach(item => {
      if (item.alias && item.badgeColor) {
        item.badge = {
          variant: item.badgeColor,
          text: ordersCounts[item.alias]
        };
      }
    });
  }*/

  return menuItems;
}
